import axios from 'axios';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import allcompanyconfig from '../../companyconfig.json';

/**
 * asks the clearMustChangePassword cloud function to remove the current user's
 * mustChangePassword custom claim, authenticating with their own ID token
 */
export default async function clearMustChangePasswordClaim() {
  const { projectId } = allcompanyconfig.firebaseConfig;
  const url = `https://us-central1-${projectId}.cloudfunctions.net/clearMustChangePassword`;
  const idToken = await firebase.auth().currentUser.getIdToken();
  await axios.post(
    url,
    {},
    { headers: { Authorization: `Bearer ${idToken}` } }
  );
}
